import React from 'react'
import PropTypes from 'prop-types'
import Container from './styled/index'
import StyledContent from './styled/loading-content'
import StyledLabel from './styled/content'
import DefaultLoading from './styled/default-loading'

const Loading = (props) => {
  const {
    style = {},
    className,
    color,
    label,
    backgroundColor,
    labelPosition = 'bottom',
    // size,
  } = props
  if (label) {
    return (
      <div style={{ display: 'inline-block' }}>
        <Container
          style={style}
          className={className}
          labelPosition={labelPosition}
          backgroundColor={backgroundColor}
        >
          <DefaultLoading backgroundColor={backgroundColor}>
            <StyledContent color={color} backgroundColor={backgroundColor} />
          </DefaultLoading>
          <StyledLabel color={color} label={label}>
            {label}
          </StyledLabel>
        </Container>
      </div>
    )
  }
  return (
    <DefaultLoading backgroundColor={backgroundColor}>
      <StyledContent
        style={style}
        color={color}
        backgroundColor={backgroundColor}
        className="text-primary"
      />
    </DefaultLoading>
  )
}
// 参数类型
Loading.propTypes = {
  // style: PropTypes.shape(PropTypes.object),
  className: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf(['bottom', 'right']),
  backgroundColor: PropTypes.string,
}
Loading.defaultProps = {
  // style: {},
  className: undefined,
  color: undefined,
  label: undefined,
  labelPosition: 'bottom',
  backgroundColor: undefined,
}
export default Loading
